<div class="global-progress-overlay" *ngIf="(progress$ | async)?.isInProgress">
  <div class="floating-progress" [class.minimized]="(progress$ | async)?.minimized">
    <div class="progress-header">
      <span>{{'new_entries.registering_users' | translate}}</span>
      <div class="actions">
        <button class="minimize-btn" (click)="toggleMinimize()">
          <i class="fas" [class.fa-minus]="!(progress$ | async)?.minimized"
            [class.fa-expand]="(progress$ | async)?.minimized"></i>
        </button>
      </div>
    </div>
    <div class="progress-content" *ngIf="!(progress$ | async)?.minimized">
      <p>{{'new_entries.progress' | translate}}: {{(progress$ | async)?.processed}}/{{(progress$ | async)?.total}}
        {{'new_entries.users_registered' | translate}}</p>
      <div class="progress-bar">
        <div class="progress" [style.width.%]="((progress$ | async)?.processed / (progress$ | async)?.total) * 100">
        </div>
      </div>
      <p class="progress-note">{{'new_entries.you_can_continue_using_the_application_while_users_are_being_registered' |
        translate}}</p>
    </div>
  </div>
</div>